import $ from 'jquery';
import WaveSurfer from 'wavesurfer.js';

$(function () {
	const $listenToArticle = $( '.js-listen-to-article' );

	if ( $listenToArticle && $listenToArticle.length ) {
		const padLeadingZeros = function( num, size = 2 ) {
			var s = num + '';

			while ( s.length < size ) {
				s = '0' + s;
			}

			return s;
		};

		const audioSrc = $listenToArticle.attr( 'data-url' );

		if ( audioSrc ) {
			const $playButton = $listenToArticle.find( '.js-play' );
			const $playbackRate = $listenToArticle.find( '.js-playback-rate' );
			const $seekProgress = $listenToArticle.find( '.js-audio-range' );
			const $currentTime = $listenToArticle.find( '.js-audio-current-time' );
			const $totalTime = $listenToArticle.find( '.js-audio-total-time' );
			const $remainingTime = $listenToArticle.find( '.js-audio-remaining-time' );
			const $loader = $listenToArticle.find( '.c-button--loading' );
			const $loaderIcon = $loader.find( '.js-loader-icon' );
			const $loaderDuration = $loader.find( '.js-loader-duration' );

			let duration = 0;

			const wavesurfer = WaveSurfer.create({
				container: document.querySelector( '#waveform' ),
				autoCenter: false,
				height: 100,
				barWidth: 4,
				barRadius: 0,
				barGap: 4,
				cursorWidth: 1,
				cursorColor: 'transparent',
				progressColor: 'rgb(0,168,142)',
				mediaControls: true,
				skipLength: 15
			});

			wavesurfer.load( audioSrc );

			wavesurfer.on('ready', function () {
				$listenToArticle.addClass( 'loaded' );
				$loader.removeClass( 'c-button--loading' );
				$loaderIcon.removeClass( 'u-hidden' );

				$loader.attr('disabled', false);
				$playButton.attr('disabled', false);
				$playbackRate.attr('disabled', false);

				duration = wavesurfer.getDuration();
				const minutes = padLeadingZeros( Math.floor( duration / 60 ) );
				const seconds = padLeadingZeros( Math.round( duration - minutes * 60 ) );

				$loaderDuration.html( `${minutes}:${seconds}` );
				$totalTime.html( `${minutes}:${seconds}` );
				$remainingTime.html( `-${minutes}:${seconds}` );

				$loader.on( 'click', function(e) {
					e.preventDefault();

					wavesurfer.playPause();

					$loader.addClass( 'u-hidden' );
					$( '.c-listen' ).removeClass( 'u-hidden' );

					if ( $playButton.hasClass( 'is-playing' ) ) {
						$playButton.removeClass( 'is-playing' );
					} else {
						$playButton.addClass( 'is-playing' );
					}
				} );

				$playButton.on( 'click', function() {
					wavesurfer.playPause();

					if ( $playButton.hasClass( 'is-playing' ) ) {
						$playButton.removeClass( 'is-playing' );
					} else {
						$playButton.addClass( 'is-playing' );
					}
				} );

				$playbackRate.on( 'click', function() {
					const rate = parseInt( $playbackRate.attr( 'data-rate' ), 10 );

					if ( 0 === rate ) {
						wavesurfer.setPlaybackRate( 1 );
						$playbackRate.find( '.js-rate' ).html( '1x' );
						$playbackRate.attr( 'data-rate', '1' );
					}

					if ( 1 === rate ) {
						wavesurfer.setPlaybackRate( 1.2 );
						$playbackRate.find( '.js-rate' ).html( '1.2x' );
						$playbackRate.attr( 'data-rate', '2' );
					}

					if ( 2 === rate ) {
						wavesurfer.setPlaybackRate( 0.8 );
						$playbackRate.find( '.js-rate' ).html( '0.8x' );
						$playbackRate.attr( 'data-rate', '0.75' );
					}
				} );

				if ( $seekProgress && $seekProgress.length ) {
					$seekProgress.on( 'change', function() {
						const $target = $( this );

						const val = $target.val();
						const min = $target.attr('min');
						const max = $target.attr('max');

						$target.css( 'background-size', `${(val - min) * 100 / (max - min)}% 100%` );
						wavesurfer.seekTo(val / 100);
					} );

					$seekProgress.on( 'click', function(e) {
						const $target = $( this );

						const min = $target.attr('min');
						const max = $target.attr('max');

						const offset = Math.round( (e.offsetX / e.target.clientWidth) *  parseInt(max,10) );

						$target.css( 'background-size', `${(offset - min) * 100 / (max - min)}% 100%` );
						$target.val(offset);
						wavesurfer.seekTo(offset / 100);
					} );
				}
			});

			wavesurfer.on( 'audioprocess', function() {
				const currentTime = wavesurfer.getCurrentTime();

				let minutes = padLeadingZeros( Math.floor( currentTime / 60 ) );
				let seconds = padLeadingZeros( Math.round( currentTime - minutes * 60 ) );

				$currentTime.html( `${minutes}:${seconds}` );

				const remainingTime = duration - currentTime;

				minutes = padLeadingZeros( Math.floor( remainingTime / 60 ) );
				seconds = padLeadingZeros( Math.round( remainingTime - minutes * 60 ) );

				$remainingTime.html( `-${minutes}:${seconds}` );

				const val = 100 * currentTime / duration;
				const min = $seekProgress.attr('min');
				const max = $seekProgress.attr('max');

				$seekProgress.val(val);
				$seekProgress.css( 'background-size', `${(val - min) * 100 / (max - min)}% 100%` );
			} );

			wavesurfer.on( 'finish', function() {
				$playButton.removeClass( 'is-playing' );
			} );
		}
	}
} );
